import { Timestamp } from 'firebase/firestore'

/** A value that may arrive as a Firestore Timestamp or an already-coerced Date. */
export type TimestampLike = Timestamp | Date | { seconds: number }

export function toDate(value: TimestampLike): Date {
  if (value instanceof Date) return value
  if (value instanceof Timestamp) return value.toDate()
  return new Date(value.seconds * 1000) // matches the legacy `seconds * 1000` coercion
}
